import { NEWS_STATUSES } from 'constants/news'

export const getStatusById = (arr = [], value) =>
  arr.filter(i => i.value === value)

export const normalizeStatusFilter = status =>
  status === NEWS_STATUSES.ALL ? '' : status
